import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import Select from 'components/Select';

const StyledSelect = styled(Select)`
  min-width: ${(props) => props.minWidth}px;

  &.Select.Select--small .Select-placeholder,
  &.Select.Select--small .Select-input {
    height: 30.1px;
  }
`;

const AssignAgentSelector = ({
  intl,
  autoFocus,
  onBlur = () => {
    /*noop*/
  },
  selectRef = {},
  className,
  value,
  handleChange,
  loadOptions,
  minWidth,
  disabled,
}) => {
  const t = intl.messages.modules.AssignAgentSelector;
  return (
    <StyledSelect
      async
      placeholder={t.search}
      noResultsText={t.notFound}
      clearable={true}
      ignoreAccents={true}
      ignoreCase={true}
      multi={false}
      value={value}
      onChange={handleChange}
      labelKey="label"
      valueKey="value"
      loadOptions={loadOptions}
      onBlurResetsInput={true}
      small
      className={className}
      innerRef={selectRef}
      autoFocus={autoFocus}
      onBlur={onBlur}
      minWidth={minWidth}
      disabled={disabled}
    />
  );
};

AssignAgentSelector.propTypes = {
  selectRef: PropTypes.func,
  className: PropTypes.func,
  value: PropTypes.any,
  handleChange: PropTypes.func,
  loadOptions: PropTypes.func,
  onBlur: PropTypes.func,
  autoFocus: PropTypes.bool,
};

AssignAgentSelector.defaultProps = {
  autoFocus: true,
};

export default injectIntl(AssignAgentSelector);
